import { render, staticRenderFns } from "./DataImplementationSearch.vue?vue&type=template&id=1becdc4a&scoped=true&"
import script from "./DataImplementationSearch.vue?vue&type=script&lang=js&"
export * from "./DataImplementationSearch.vue?vue&type=script&lang=js&"
import style0 from "./DataImplementationSearch.vue?vue&type=style&index=0&id=1becdc4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1becdc4a",
  null
  
)

export default component.exports